import { Permissions } from "../../../models/enums/permissions";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class UserCreate {
    
    @ValidateProperty({ required: true })
    public email : string = '';
    
    /** What the user holds, by service center */
    public permissions : { [serviceCenter: string]: Permissions[] } = {};

}
